import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../utils/auth';

const PirateCompendium = () => {
  const navigate = useNavigate();
  const apiUrl = encodeURIComponent(API_URL);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100dvh',
        overflow: 'hidden',
      }}
    >
      <button
        onClick={() => navigate('/projects/Pirate')}
        style={{
          position: 'absolute',
          top: '8px',
          left: '12px',
          zIndex: 1000,
          minWidth: '104px',
          padding: '9px 14px',
          border: '1px solid rgba(217, 187, 121, 0.45)',
          borderRadius: '6px',
          background: 'rgba(47, 36, 23, 0.92)',
          color: '#f6edd7',
          cursor: 'pointer',
          fontFamily: '"Trebuchet MS", sans-serif',
          fontSize: '0.92rem',
          fontWeight: 700,
          boxSizing: 'border-box',
          boxShadow: '0 8px 20px rgba(47, 36, 23, 0.18)',
        }}
      >
        &lt; Back
      </button>

      <iframe
        src={`/games/PirateSystem/PirateCompendium.html?apiUrl=${apiUrl}`}
        title="Pirate Compendium"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
        }}
      />
    </div>
  );
};

export default PirateCompendium;
